import { BACKEND_URL } from '../utils/constants'

export const create = async (contact) => {
    const url = `${BACKEND_URL}/contacts`
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(contact),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      return response.json()
    } else {
      throw response.json()
    }
  }